export default __webpack_public_path__ + "static/media/hx.a9e6c2b7.svg";